<script>
import CartAPI from "../../classes/API/CartAPI.js";
import bus from 'vue3-eventbus';
import {reactive} from "vue";
import Price from "../Price.vue";
import {ModalsContainer, useModal} from 'vue-final-modal'
import Modal from "$vueCommon/components/Modal.vue";
import DomainItemContact from "./DomainItemContact.vue";
import DomainItemDnsProfile from '$vueCommon/components/Cart/DomainItemDnsProfile.vue';
import {ToastMessageDanger, ToastMessageSuccess} from "$vueCommon/classes/ToastMessage.js";
import eventBus from "vue3-eventbus";

export default {
    components: {
        Price
    },
    props: {
        item: Object
    },
    methods: {
    },
    watch: {
    },
    computed: {
    }
}
</script>
<template>
    <div class="card cart-item cart-item-fee">
        <div class="card-body">
            <div class="row align-items-center">
                <div class="col-8 d-flex align-items-center">
                    <div class="cart-item-icon"></div>
                    <h3 class="mb-0">
                        {{ item.name }}
                    </h3>
                </div>
                <div class="col-4 text-end">
                    <h3 class="mb-0">
                        <Price :price="item.price" :promo-price="item.promoPrice"></Price>
                    </h3>
                </div>
            </div>
        </div>
    </div>
</template>
